import { useQuery } from '@tanstack/react-query';
import { getDeficiencyDetail } from '../services/DeficiencyServices';
export default function useDeficiencyDetail(id) {
    return useQuery(['deficiency', id], () => getDeficiencyDetail(id), {
        staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
        cacheTime: 30 * 60 * 1000 // Keep unused data in cache for 30 minutes
    });
}
